import { createApp } from 'vue'
import App from './App.vue'

import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import '@/styles/theme.css'

import { registerPlugins } from '@/plugins'
import { consumeAccessTokenFromUrl } from '@/composables/useAuth'

consumeAccessTokenFromUrl()

const app = createApp(App)
registerPlugins(app)
app.mount('#app')
